import { render, staticRenderFns } from "./EmailSuggestionList.vue?vue&type=template&id=cec7b03a&scoped=true&"
import script from "./EmailSuggestionList.vue?vue&type=script&lang=js&"
export * from "./EmailSuggestionList.vue?vue&type=script&lang=js&"
import style0 from "./EmailSuggestionList.vue?vue&type=style&index=0&id=cec7b03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec7b03a",
  null
  
)

export default component.exports